export type RouterMode = 'browser' | 'hash';

export function getRouterMode(): RouterMode {
  const configured = import.meta.env.VITE_ROUTER_MODE;

  if (configured === 'browser' || configured === 'hash') {
    return configured;
  }

  if (window.location.protocol === 'file:') {
    return 'hash';
  }

  return 'browser';
}

export function getCurrentAppPath() {
  if (getRouterMode() === 'hash') {
    const hashPath = window.location.hash.replace(/^#/, '');
    return hashPath || '/';
  }

  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function toAppHref(path: string) {
  if (getRouterMode() === 'hash') {
    return `#${path}`;
  }

  return path;
}

export function assignAppPath(path: string) {
  if (getRouterMode() === 'hash') {
    window.location.hash = path;
    return;
  }

  window.location.assign(path);
}
